import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["addResourceBundle"];
import { useTranslation } from '@crehana/i18n';
import { PROFILE_UI_TRANSLATIONS_KEY } from "../constants";
import en from "./localeEn";
import es from "./localeEs";
import pt from "./localePt";
var locales = {
  es: es,
  pt: pt,
  en: en
};
var useProfileUITranslations = function useProfileUITranslations() {
  var _useTranslation = useTranslation(PROFILE_UI_TRANSLATIONS_KEY),
    addResourceBundle = _useTranslation.addResourceBundle,
    contextValue = _objectWithoutProperties(_useTranslation, _excluded);
  addResourceBundle(locales);
  return contextValue;
};
export default useProfileUITranslations;